<div class="container-fluid admin-page orders-page">
    <header class="admin-page-header">
        <div>
            <h1>{{ 'Orders' | translate }}</h1>
            <p>{{ 'Browse all completed orders and inspect their full route and details.' | translate }}</p>
        </div>
        <div class="admin-header-actions">
            <button (click)="loadOrders()" [disabled]="isLoading" class="admin-refresh-button" type="button">
                <i [class.spinning]="isLoading"
                   class="material-icons">refresh</i><span>{{ 'Refresh' | translate }}</span>
            </button>
        </div>
    </header>

    <form (ngSubmit)="search()" class="orders-toolbar admin-toolbar">
        <label class="search-field admin-search-field">
            <span>{{ 'Client phone number' | translate }}</span>
            <div class="search-input-wrap admin-search-input">
                <i class="material-icons">phone</i>
                <input [(ngModel)]="phoneNumber" [disabled]="isLoading" autocomplete="off" inputmode="tel"
                       [placeholder]="'Search by client phone number' | translate" name="phoneNumber" type="search">
                <button (click)="clearSearch()"
                        *ngIf="phoneNumber !== '' || appliedPhoneNumber !== '' || carFilter !== ''
                            || appliedCarFilter !== '' || statusFilter !== '' || appliedStatusFilter !== ''
                            || sourceFilter !== '' || appliedSourceFilter !== ''
                            || paymentMethodFilter !== '' || appliedPaymentMethodFilter !== ''"
                        [attr.aria-label]="'Clear order filters' | translate" [disabled]="isLoading"
                        class="clear-search" type="button">
                    <i class="material-icons">close</i>
                </button>
            </div>
        </label>
        <label class="admin-filter-field">
            <span>{{ 'Car' | translate }}</span>
            <input [(ngModel)]="carFilter" [disabled]="isLoading" autocomplete="off"
                   [placeholder]="'Car ID or number' | translate" name="carFilter" type="search">
        </label>
        <label class="admin-filter-field">
            <span>{{ 'Status' | translate }}</span>
            <select [(ngModel)]="statusFilter" [disabled]="isLoading" name="statusFilter">
                <option value="">{{ 'All statuses' | translate }}</option>
                <option value="created">{{ 'Created' | translate }}</option>
                <option value="timeout">{{ 'Server timeout' | translate }}</option>
                <option value="assigned">{{ 'Assigned' | translate }}</option>
                <option value="approaching">{{ 'Approaching' | translate }}</option>
                <option value="arrived">{{ 'Arrived' | translate }}</option>
                <option value="clientPicked">{{ 'Client picked' | translate }}</option>
                <option value="onTheWay">{{ 'On the way' | translate }}</option>
                <option value="finished">{{ 'Finished' | translate }}</option>
                <option value="clientCanceled">{{ 'Canceled by customer' | translate }}</option>
                <option value="driverCanceled">{{ 'Canceled by driver' | translate }}</option>
            </select>
        </label>
        <label class="admin-filter-field">
            <span>{{ 'Source' | translate }}</span>
            <select [(ngModel)]="sourceFilter" [disabled]="isLoading" name="sourceFilter">
                <option value="">{{ 'All sources' | translate }}</option>
                <option value="ios">iOS</option>
                <option value="android">Android</option>
                <option value="airport">{{ 'Airport' | translate }}</option>
                <option value="posandroid">POS Android</option>
                <option value="broadcast">{{ 'Dispatch' | translate }}</option>
                <option value="driver">{{ 'Street Order' | translate }}</option>
            </select>
        </label>
        <label class="admin-filter-field">
            <span>{{ 'Payment method' | translate }}</span>
            <select [(ngModel)]="paymentMethodFilter" [disabled]="isLoading" name="paymentMethodFilter">
                <option value="">{{ 'All payment methods' | translate }}</option>
                <option value="cash">{{ 'Cash' | translate }}</option>
                <option value="card">{{ 'Card' | translate }}</option>
                <option value="voucher">{{ 'Voucher' | translate }}</option>
            </select>
        </label>
        <button [disabled]="isLoading" class="search-button" type="submit">
            <i class="material-icons">search</i><span>{{ 'Search' | translate }}</span>
        </button>
        <label class="page-size admin-page-size">
            <span>{{ 'Rows' | translate }}</span>
            <select (change)="changePageSize()" [(ngModel)]="pageSize" [disabled]="isLoading" name="pageSize">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
            </select>
        </label>
    </form>

    <div *ngIf="hasAppliedFilters()" class="active-filter">
        <i class="material-icons">filter_list</i>
        <span *ngIf="appliedPhoneNumber !== ''">{{ 'Phone' | translate }}
            : <strong>{{ appliedPhoneNumber }}</strong></span>
        <span *ngIf="appliedCarFilter !== ''">{{ 'Car' | translate }}: <strong>{{ appliedCarFilter }}</strong></span>
        <span *ngIf="appliedStatusFilter !== ''">{{ 'Status' | translate }}
            : <strong>{{ appliedStatusFilter | translate }}</strong></span>
        <span *ngIf="appliedSourceFilter !== ''">
            {{ 'Source' | translate }}: <strong>{{ getSourceLabel(appliedSourceFilter) | translate }}</strong>
        </span>
        <span *ngIf="appliedPaymentMethodFilter !== ''">
            {{ 'Payment' | translate }}: <strong>{{ appliedPaymentMethodFilter | translate }}</strong>
        </span>
    </div>

    <div *ngIf="isLoading" class="state-card admin-page-state">
        <i class="material-icons spinning">refresh</i><span>{{ 'Loading orders...' | translate }}</span>
    </div>
    <div *ngIf="!isLoading && loadError !== ''" class="state-card admin-page-state error-state">
        <i class="material-icons">error_outline</i><span>{{ loadError | translate }}</span>
        <button (click)="loadOrders()" type="button">{{ 'Try again' | translate }}</button>
    </div>

    <ng-container *ngIf="!isLoading && loadError === ''">
        <div *ngIf="orders.length > 0" class="orders-table-wrap admin-data-table-wrap">
            <table class="orders-table admin-data-table">
                <thead>
                <tr>
                    <th [attr.aria-sort]="tableSort.getAriaSort('date')">
                        <button (click)="tableSort.toggle('date')" class="admin-sort-button" type="button">
                            <span>{{ 'Date' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('date', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('date', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('source')">
                        <button (click)="tableSort.toggle('source')" class="admin-sort-button" type="button">
                            <span>{{ 'Source' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('source', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('source', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('client')">
                        <button (click)="tableSort.toggle('client')" class="admin-sort-button" type="button">
                            <span>{{ 'Client' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('client', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('client', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('phone')">
                        <button (click)="tableSort.toggle('phone')" class="admin-sort-button" type="button">
                            <span>{{ 'Phone' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('phone', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('phone', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('pickup')">
                        <button (click)="tableSort.toggle('pickup')" class="admin-sort-button" type="button">
                            <span>{{ 'Pickup' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('pickup', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('pickup', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('car')">
                        <button (click)="tableSort.toggle('car')" class="admin-sort-button" type="button">
                            <span>{{ 'Car' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('car', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('car', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('status')">
                        <button (click)="tableSort.toggle('status')" class="admin-sort-button" type="button">
                            <span>{{ 'Status' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('status', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('status', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('price')">
                        <button (click)="tableSort.toggle('price')" class="admin-sort-button" type="button">
                            <span>{{ 'Price' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('price', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('price', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('paymentMethod')">
                        <button (click)="tableSort.toggle('paymentMethod')" class="admin-sort-button" type="button">
                            <span>{{ 'Payment method' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('paymentMethod', 'asc')"
                                   class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('paymentMethod', 'desc')"
                                   class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr (click)="openDetails(order)" (keydown.enter)="openDetails(order)"
                    *ngFor="let order of getSortedOrders()" class="order-row" tabindex="0">
                    <td [attr.data-label]="'Date' | translate">{{ getEntryDate(order) | date:'dd.MM.yyyy HH:mm' }}</td>
                    <td [attr.data-label]="'Source' | translate">{{ getOrderSource(order) | translate }}</td>
                    <td [attr.data-label]="'Client' | translate">{{ getClientName(order) }}</td>
                    <td [attr.data-label]="'Phone' | translate">{{ getClientPhone(order) }}</td>
                    <td [attr.data-label]="'Pickup' | translate"
                        class="address-cell">{{ formatAddress(getPickupAddress(order)) }}
                    </td>
                    <td [attr.data-label]="'Car' | translate">{{ getCarDisplay(order) }}</td>
                    <td [attr.data-label]="'Status' | translate"><span
                            class="status-pill">{{ getOrderStatus(order) | translate }}</span></td>
                    <td [attr.data-label]="'Price' | translate">{{ getPrice(order) }}</td>
                    <td [attr.data-label]="'Payment method' | translate">{{ getPaymentMethod(order) | translate }}</td>
                    <td class="details-cell">
                        <button (click)="openDetails(order); $event.stopPropagation()"
                                [attr.aria-label]="'Open order details' | translate"
                                class="details-button" type="button"><i class="material-icons">chevron_right</i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div *ngIf="orders.length === 0" class="state-card admin-page-state empty-state">
            <i class="material-icons">receipt</i>
            <span>{{ (hasAppliedFilters() ? 'No orders match these filters.' : 'No orders were found.') | translate }}</span>
            <button (click)="clearSearch()" *ngIf="hasAppliedFilters()"
                    type="button">{{ 'Clear filters' | translate }}
            </button>
        </div>

        <footer *ngIf="totalCount > 0" class="pagination admin-pagination">
            <span class="pagination-summary admin-pagination-summary">{{ getFirstItemNumber() }}
                –{{ getLastItemNumber() }} {{ 'of' | translate }} {{ totalCount }}</span>
            <nav [attr.aria-label]="'Orders pages' | translate" class="pagination-buttons admin-pagination-buttons">
                <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1 || isLoading"
                        [attr.aria-label]="'Previous page' | translate" type="button"><i class="material-icons">chevron_left</i>
                </button>
                <button (click)="goToPage(page)" *ngFor="let page of getVisiblePages()"
                        [attr.aria-current]="page === currentPage ? 'page' : null" [class.active]="page === currentPage"
                        type="button">{{ page }}
                </button>
                <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages || isLoading"
                        [attr.aria-label]="'Next page' | translate" type="button"><i class="material-icons">chevron_right</i>
                </button>
            </nav>
        </footer>
    </ng-container>
</div>

<app-order-details (closed)="closeDetails()" [order]="selectedOrder"></app-order-details>
